<div class="content-wrapper">

  <section class="content-header">
    <h1>
      Entidade
      <small>Visualizar</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/home">
          <i class="fa fa-home"></i> Home</a>
      </li>
      <li class="active">Informações da entidade</li>
    </ol>
  </section>

  <br>

  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body">


        <div class="col-md-12">

          <router-outlet></router-outlet>

        </div>

      </div>


      <br>
      <div class="box-footer clearfix"></div>

    </div>

  </div>

</div>